class Current {
  get user() {
    const currentUserId = this.#extractContentFromMetaTag("current-user-id");

    if (currentUserId) {
      return {
        id: currentUserId,
        name: this.#extractContentFromMetaTag("current-user-name"),
      };
    }
  }

  #extractContentFromMetaTag(name: string) {
    return document.head
      .querySelector(`meta[name="${name}"]`)
      ?.getAttribute("content");
  }
}
interface Window {
  Current: Current;
}

window.Current = new Current();
